module.exports = __webpack_public_path__ + "img/SteelBridgeSupport.db7c52bd.jpg";